// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/js/main.48c60db1.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3217a83f","239":"b2160010","488":"ff06ea8e","667":"ab65563d"}[chunkId] + ".chunk.js";
};